import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import '../styles/ActivityDrawer.css';
const ActivityDrawer = ({ isOpen, activityUrl, onClose }) => {
    const [shouldAnimate, setShouldAnimate] = useState(false);
    // Handle animation trigger
    useEffect(() => {
        if (isOpen) {
            // Small delay to trigger CSS transition
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setShouldAnimate(true);
                });
            });
        }
        else {
            setShouldAnimate(false);
        }
    }, [isOpen]);
    // Handle escape key to close drawer
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    return (_jsxs("div", { className: `activity-drawer ${shouldAnimate ? 'activity-drawer-open' : ''}`, children: [_jsx("div", { className: "activity-drawer-header", children: _jsxs("button", { className: "activity-drawer-back-btn", onClick: onClose, "aria-label": "Back to activities", children: [_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M19 12H5M5 12L12 19M5 12L12 5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }), _jsx("span", { children: "Back" })] }) }), _jsx("div", { className: "activity-drawer-content", children: _jsx("iframe", { src: activityUrl, title: "Activity", className: "activity-drawer-iframe", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }) })] }));
};
export default ActivityDrawer;
